import { useInfiniteQuery, useMutation } from "react-query";
import useApi from "./useApiRequest";


const LIMIT = 20;

const fetchPage = (api, ajusteId, almacen, filtros, isClose, tagExc) => async ({ pageParam }) => {
  // pageParam trae { page, searchOnDoc }; define default
  const { page = 1, pageTag = 1, searchOnDoc = true } = pageParam || { page: 1, pageTag: 1, searchOnDoc: true };
  const res = await api.get(`/ajustes-inventario/movimientos-nuevo-ajuste/${ajusteId}`, {
    params: { page, pageTag, limit: LIMIT, searchOnDoc, almacen, filtros, isClose, tagExc },
  });

  const data = res.data; // adapta si tu backend envía otra estructura

  // deducir si se llegó al fin del “modo” actual:
  const items = data?.movs_inv || data?.items || data?.results || data?.rows || data?.data || [];
  const hasNextPageMovs = data?.hasNextPageMovs; // si no existe, usa: items.length === LIMIT
  // Calcula el PRÓXIMO pageParam:
  let nextPageParam = undefined;

  if (!hasNextPageMovs && items.length > 0) {
    let incMovs = items.some(i => i.fromDocMov === true);
    if (incMovs) {
      nextPageParam = { page: page + 1, pageTag: pageTag + 1, searchOnDoc: false }
    } else {
      nextPageParam = { pageTag: pageTag + 1, searchOnDoc: false }
    }
  } else if (items.length > 0) {
    nextPageParam = { page: page + 1, searchOnDoc: true }
  }

  // Devuelve datos + metadata para getNextPageParam
  return {
    items,
    hasNextPageMovs,
    used: { page, pageTag, searchOnDoc },             // por si lo quieres mostrar en UI
    nextPageParam,
  };
};

export const useInfiniteItemsAjuste = (ajusteId, almacen, options = {}, filtros, isClose, tagExc) => {
  const api = useApi();
  return useInfiniteQuery(
    ["infiniteItemsAjuste", { ajusteId, almacen, filtros: JSON.stringify(filtros), isClose: JSON.stringify(isClose) }],
    fetchPage(api, ajusteId, almacen, JSON.stringify(filtros), JSON.stringify(isClose), JSON.stringify(tagExc)),
    {
      // Empezamos en page=1, modo documentos (true)
      initialPageParam: { page: 1, pageTag: 1, searchOnDoc: true },

      // v3/v4: solo (lastPage, allPages)
      getNextPageParam: (lastPage /*, allPages */) => {
        return lastPage?.nextPageParam ?? undefined;
      },

      keepPreviousData: true,
      staleTime: 600,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      cacheTime: 30,
      ...options
    }
  );
};

export const GetOnlyAjuste = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.get(`/ajustes-inventario/head-ajuste/${params}`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    getOnlyAjusteMutation: mutation.mutate,
  };
}

export const AddTagMultiple = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/ajustes-inventario/multiple/add-tag`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    addTagMultipleMutation: mutation.mutate,
  };
}

export const DeleteTagMultiple = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/ajustes-inventario/multiple/delete-tag`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    deleteTagMultipleMutation: mutation.mutate,
  };
}

export const ProcessAll = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/ajustes-inventario/process-all`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    processAllMutation: mutation.mutate,
  };
}
export const ProcessPartial = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/ajustes-inventario/process-all/partial`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    processPartialMutation: mutation.mutate,
  };
}